import constants from '@/constant'
import presentingRight from '@/constant/user-presenting-right'

const isTreatmentSlideTypePreview = (state) => {
  return state.currentUser.abTest &&
    state.currentUser.abTest[constants.AB_TEST.SLIDE_TYPE_PREVIEW] === constants.AB_VARIANT.TREATMENT
}
const isTreatmentPlanUpgradeEditor = (state) => {
  return state.currentUser.abTest &&
    state.currentUser.abTest[constants.AB_TEST.PLAN_UPGRADE_EDITOR] === constants.AB_VARIANT.TREATMENT
}

const isEnableUserPresentingRight = (state) => {
  if (state.currentUser.id && presentingRight.usersPresentingRight.has(state.currentUser.id)) return true
  return false
}

const isEnableEditorPresentingRight = (state) => {
  if (state.presentation.User && presentingRight.usersPresentingRight.has(state.presentation.User.id)) return true
  return false
}

export default {
  isTreatmentSlideTypePreview,
  isTreatmentPlanUpgradeEditor,
  isEnableUserPresentingRight,
  isEnableEditorPresentingRight,
}
